import { IImageAsset } from '@move-frontend/contentful';
import { ImageOrientation } from '../contentful/types/ImageOrientation';
import { IResponsiveImageSource, getResponsiveContentfulImageUrl } from '../ui';

export function getContactImageSource(
	image: IImageAsset | undefined,
	imageOrientation?: ImageOrientation,
): IResponsiveImageSource {
	if (!image) {
		return '';
	}

	const { url } = image.fields.file;

	if (imageOrientation === 'Portrait') {
		getResponsiveContentfulImageUrl(url, {
			w: 360,
			h: 440,
		});
	}
	return [
		getResponsiveContentfulImageUrl(url, {
			w: 780,
			h: 260,
		}),
		{
			tablet: getResponsiveContentfulImageUrl(url, {
				w: 900,
				h: 300,
			}),
			mobileXL: getResponsiveContentfulImageUrl(url, {
				w: 1380,
				h: 460,
			}),
			mobile: getResponsiveContentfulImageUrl(url, {
				w: 900,
				h: 300,
			}),
		},
	];
}
